import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateOtaReleaseMutationVariables = Types.Exact<{
  input: Types.CreateOtaReleaseInput;
}>;


export type CreateOtaReleaseMutation = { __typename?: 'Mutation', createOtaRelease: { __typename?: 'OtaReleasePayload', release?: { __typename?: 'OtaReleaseStateData', releaseId: string, status: Types.OtaReleaseStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PublishOtaReleaseMutationVariables = Types.Exact<{
  input: Types.PublishOtaReleaseInput;
}>;


export type PublishOtaReleaseMutation = { __typename?: 'Mutation', publishOtaRelease: { __typename?: 'OtaReleasePayload', release?: { __typename?: 'OtaReleaseStateData', releaseId: string, status: Types.OtaReleaseStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type HaltOtaReleaseMutationVariables = Types.Exact<{
  input: Types.HaltOtaReleaseInput;
}>;


export type HaltOtaReleaseMutation = { __typename?: 'Mutation', haltOtaRelease: { __typename?: 'OtaReleasePayload', release?: { __typename?: 'OtaReleaseStateData', releaseId: string, status: Types.OtaReleaseStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartOtaRolloutMutationVariables = Types.Exact<{
  input: Types.StartOtaRolloutInput;
}>;


export type StartOtaRolloutMutation = { __typename?: 'Mutation', startOtaRollout: { __typename?: 'OtaRolloutPayload', operation?: { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PromoteOtaRolloutRingMutationVariables = Types.Exact<{
  input: Types.PromoteOtaRolloutRingInput;
}>;


export type PromoteOtaRolloutRingMutation = { __typename?: 'Mutation', promoteOtaRolloutRing: { __typename?: 'OtaRolloutPayload', operation?: { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PauseOtaRolloutMutationVariables = Types.Exact<{
  input: Types.PauseOtaRolloutInput;
}>;


export type PauseOtaRolloutMutation = { __typename?: 'Mutation', pauseOtaRollout: { __typename?: 'OtaRolloutPayload', operation?: { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ResumeOtaRolloutMutationVariables = Types.Exact<{
  input: Types.ResumeOtaRolloutInput;
}>;


export type ResumeOtaRolloutMutation = { __typename?: 'Mutation', resumeOtaRollout: { __typename?: 'OtaRolloutPayload', operation?: { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AbortOtaRolloutMutationVariables = Types.Exact<{
  input: Types.AbortOtaRolloutInput;
}>;


export type AbortOtaRolloutMutation = { __typename?: 'Mutation', abortOtaRollout: { __typename?: 'OtaRolloutPayload', operation?: { __typename?: 'OtaRolloutOperationData', applied: boolean, reason: Types.OtaNoOpReason, rollout?: { __typename?: 'OtaRolloutStateData', rolloutId: string, status: Types.OtaRolloutStatus, currentRing: number } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateOtaReleaseDocument = new TypedDocumentString(`
    mutation CreateOtaRelease($input: CreateOtaReleaseInput!) {
  createOtaRelease(input: $input) {
    release {
      ...OtaReleaseState
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaReleaseState on OtaReleaseStateData {
  releaseId
  status
}`);
export const PublishOtaReleaseDocument = new TypedDocumentString(`
    mutation PublishOtaRelease($input: PublishOtaReleaseInput!) {
  publishOtaRelease(input: $input) {
    release {
      ...OtaReleaseState
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaReleaseState on OtaReleaseStateData {
  releaseId
  status
}`);
export const HaltOtaReleaseDocument = new TypedDocumentString(`
    mutation HaltOtaRelease($input: HaltOtaReleaseInput!) {
  haltOtaRelease(input: $input) {
    release {
      ...OtaReleaseState
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaReleaseState on OtaReleaseStateData {
  releaseId
  status
}`);
export const StartOtaRolloutDocument = new TypedDocumentString(`
    mutation StartOtaRollout($input: StartOtaRolloutInput!) {
  startOtaRollout(input: $input) {
    operation {
      ...OtaRolloutOperation
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`);
export const PromoteOtaRolloutRingDocument = new TypedDocumentString(`
    mutation PromoteOtaRolloutRing($input: PromoteOtaRolloutRingInput!) {
  promoteOtaRolloutRing(input: $input) {
    operation {
      ...OtaRolloutOperation
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`);
export const PauseOtaRolloutDocument = new TypedDocumentString(`
    mutation PauseOtaRollout($input: PauseOtaRolloutInput!) {
  pauseOtaRollout(input: $input) {
    operation {
      ...OtaRolloutOperation
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`);
export const ResumeOtaRolloutDocument = new TypedDocumentString(`
    mutation ResumeOtaRollout($input: ResumeOtaRolloutInput!) {
  resumeOtaRollout(input: $input) {
    operation {
      ...OtaRolloutOperation
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`);
export const AbortOtaRolloutDocument = new TypedDocumentString(`
    mutation AbortOtaRollout($input: AbortOtaRolloutInput!) {
  abortOtaRollout(input: $input) {
    operation {
      ...OtaRolloutOperation
    }
    errors {
      code
      message
    }
  }
}
    fragment OtaRolloutOperation on OtaRolloutOperationData {
  applied
  reason
  rollout {
    ...OtaRolloutState
  }
}
fragment OtaRolloutState on OtaRolloutStateData {
  rolloutId
  status
  currentRing
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateOtaRelease: build.mutation<CreateOtaReleaseMutation, CreateOtaReleaseMutationVariables>({
      query: (variables) => ({ document: CreateOtaReleaseDocument, variables })
    }),
    PublishOtaRelease: build.mutation<PublishOtaReleaseMutation, PublishOtaReleaseMutationVariables>({
      query: (variables) => ({ document: PublishOtaReleaseDocument, variables })
    }),
    HaltOtaRelease: build.mutation<HaltOtaReleaseMutation, HaltOtaReleaseMutationVariables>({
      query: (variables) => ({ document: HaltOtaReleaseDocument, variables })
    }),
    StartOtaRollout: build.mutation<StartOtaRolloutMutation, StartOtaRolloutMutationVariables>({
      query: (variables) => ({ document: StartOtaRolloutDocument, variables })
    }),
    PromoteOtaRolloutRing: build.mutation<PromoteOtaRolloutRingMutation, PromoteOtaRolloutRingMutationVariables>({
      query: (variables) => ({ document: PromoteOtaRolloutRingDocument, variables })
    }),
    PauseOtaRollout: build.mutation<PauseOtaRolloutMutation, PauseOtaRolloutMutationVariables>({
      query: (variables) => ({ document: PauseOtaRolloutDocument, variables })
    }),
    ResumeOtaRollout: build.mutation<ResumeOtaRolloutMutation, ResumeOtaRolloutMutationVariables>({
      query: (variables) => ({ document: ResumeOtaRolloutDocument, variables })
    }),
    AbortOtaRollout: build.mutation<AbortOtaRolloutMutation, AbortOtaRolloutMutationVariables>({
      query: (variables) => ({ document: AbortOtaRolloutDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateOtaReleaseMutation, usePublishOtaReleaseMutation, useHaltOtaReleaseMutation, useStartOtaRolloutMutation, usePromoteOtaRolloutRingMutation, usePauseOtaRolloutMutation, useResumeOtaRolloutMutation, useAbortOtaRolloutMutation } = injectedRtkApi;
